module.exports = __webpack_public_path__ + "img/Осенняя лазурь. х-м 70х90. 2003г. 800$.9804fd4b.jpg";